import { render, staticRenderFns } from "./ClosedNIOList.vue?vue&type=template&id=2d60b405&scoped=true&"
import script from "./ClosedNIOList.vue?vue&type=script&lang=js&"
export * from "./ClosedNIOList.vue?vue&type=script&lang=js&"
import style0 from "./ClosedNIOList.vue?vue&type=style&index=0&id=2d60b405&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60b405",
  null
  
)

export default component.exports